import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/Button"
import { isiOS } from "@/utils"

import { PWABanner } from "./PWABanner"
import { usePWABannerPrompt } from "./usePWABannerPrompt"

export const LaunchButtonInner = ({
  onClick,
  hasPrompt,
}: {
  onClick: () => void
  hasPrompt: boolean
}) => {
  const { t } = useTranslation()
  return (
    <Button variant="outline" size="lg" onClick={onClick}>
      {t(hasPrompt ? "pwa.installPwa" : "pwa.install")}
    </Button>
  )
}

interface InstallLaunchProps {
  state: string | null
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
}

export const PWALaunchButton = ({
  state,
  setIsModalOpen,
}: InstallLaunchProps) => {
  const [prompt, promptToInstall] = usePWABannerPrompt()

  if (!prompt && isiOS && state === PWABanner.Hidden) {
    return (
      <LaunchButtonInner
        onClick={() => setIsModalOpen(true)}
        hasPrompt={false}
      />
    )
  } else if (prompt && state === PWABanner.Hidden) {
    return <LaunchButtonInner onClick={promptToInstall} hasPrompt />
  }

  return null
}
